/* Fabrica Kraft – builder size prefill (20 Oct 2026)
   Lets a link open a builder with the size already set, e.g.
   /products/custom-deep-seat-cushions-sunbrella?use=outdoor&w=24&d=24&t=5
   w = width, d = depth (inches, rounded to 1/4", clamped to the builder's limits),
   t = thickness (only applied if that chip exists). No-op on pages without the builder
   or without these parameters. */
(function () {
  var q;
  try { q = new URLSearchParams(location.search); } catch (e) { return; }
  var w = q.get('w'), d = q.get('d'), t = q.get('t');
  if (!w && !d && !t) return;

  function num(v) { v = parseFloat(v); return isFinite(v) && v > 0 ? v : null; }

  function setDim(el, v) {
    if (!el || v == null) return;
    var lo = parseFloat(el.getAttribute('data-lo')), hi = parseFloat(el.getAttribute('data-hi'));
    if (isFinite(lo)) v = Math.max(lo, v);
    if (isFinite(hi)) v = Math.min(hi, v);
    v = Math.round(v * 4) / 4;
    el.value = String(v);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setThick(root, v) {
    if (v == null) return;
    var g = root.querySelector('[data-fks="thick"]');
    if (!g) return;
    var opts = g.querySelectorAll('button,[role="radio"]');
    for (var i = 0; i < opts.length; i++) {
      if (parseFloat(opts[i].textContent) === v) { opts[i].click(); return; }
    }
  }

  var tries = 0;
  (function go() {
    var W = document.querySelector('input[id^="fks-w-"]');
    var D = document.querySelector('input[id^="fks-d-"]');
    if (!W || !D) { if (++tries < 80) setTimeout(go, 250); return; }
    var root = W.closest('.fks') || document;
    function apply() {
      setThick(root, num(t));
      setDim(W, num(w));
      setDim(D, num(d));
    }
    // Let the builder finish its own first render, apply, then re-apply once
    // if the builder reset the fields while it was still initialising.
    setTimeout(function () {
      apply();
      var wantW = W.value, wantD = D.value;
      setTimeout(function () {
        if (W.value !== wantW || D.value !== wantD) apply();
      }, 1200);
    }, 400);
  })();
})();
